import React from 'react';
import MenuButtonFilter, { MenuButtonFilterItem } from '@app/component/menu/MenuButtonFilter';
import ReviewsFilterInput from '@app/model/review/input/ReviewsFilterInput';
import { useCompanyHotels } from '@app/site/secured/rateshopper/rates/provider/useCompanyHotels';
import Rating from '@app/component/rating/Rating';
import Location from '@app/model/hotel/Location';

type ReviewsRatingButtonFilterProps = {
	filter: ReviewsFilterInput;
	onFilter: (filter: ReviewsFilterInput) => void;
	isStandAlone?: boolean
};

const ReviewsCompanyHotelButtonFilter = React.memo(
	function ReviewsCompanyHotelButtonFilter({ filter, onFilter, isStandAlone }: ReviewsRatingButtonFilterProps) {

		const { companyHotels } = useCompanyHotels();

		const menuItems = companyHotels.map(ch => {
			return {
				name: ch.mainHotelName,
				value: ch.id,
				props: {
					location: ch.mainHotelLocation,
					rating: ch.mainHotelRating,
					ratingType: ch.mainHotelRatingType,
				},
			};
		});

		const onSelect = (value: number) => {
			onFilter({
				...filter,
				companyHotelId: value,
			});
		};

		const displayAddress = (location: Location) => {
			let address = location?.address;
			if (location?.city) {
				address += `, ${location.city}`;
			}
			if (location?.country?.name) {
				address += `, ${location.country.name}`;
			}

			return address;
		};

		const displaySelectedItem = (item: MenuButtonFilterItem) => {
			return <div className="text-left flex-none">
				<div className=" text-xl font-bold leading-6">{item.name}</div>
				<div className="sm:flex items-center mt-0.5">
					<span className="text-sm font-light text-gray-400 leading-3">{displayAddress(item.props.location)}</span>
					<span className="mx-2 text-gray-300">&bull;</span>
					<div className="flex items-center text-sm text-gray-200">
						<Rating rating={item.props.rating} ratingType={item.props.ratingType} />
					</div>
				</div>
			</div>;
		};

		return isStandAlone ?
			<MenuButtonFilter menuItems={menuItems} selectedValue={filter.companyHotelId} onSelect={onSelect} menuWidth="w-96"
												buttonClassName="flex items-top gap-x-2 text-gray-900 hover:text-blue-600 bg-gray-100 text-xl font-bold leading-6"
												displaySelectedItem={displaySelectedItem} /> :
			<MenuButtonFilter menuItems={menuItems} selectedValue={filter.companyHotelId} onSelect={onSelect}
												menuWidth="w-96" />;
	},
);

export default ReviewsCompanyHotelButtonFilter;